import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { format, utcToZonedTime } from 'date-fns-tz';
import Tippy from '@tippyjs/react';
import ReactModal from 'react-modal';
import { TbSearch } from 'react-icons/tb';
import InputMask from 'react-input-mask';
import { findManagers, findPlayer, getLinkedIndicators } from 'services/profile.service';
import { LinkedIndicators_Indicadores, User } from 'types/user';
import { RiCloseLine, RiSearchLine } from 'react-icons/ri';
import { useAuth } from 'context/AuthContext';
import Box from 'components/ui/box';
import { BiInfoCircle } from 'react-icons/bi';
import {
  CheckTotalTasksParticipationMember,
  deleteMissionFeedback,
  getPlayerInfo,
  getServerTime,
  getTaskById,
  sendNotificationTask,
  sendPreferenceNotification,
  submitTask,
  updateTask,
  verifyTask,
  getPartialTask,
  sendPartialTask,
} from 'services/dashboard.service';
import { UserAvatar } from 'components/user-avatar';
import { IoMdCloseCircle } from 'react-icons/io';
import { MdOutlineExpandMore, MdOutlineExpandLess } from 'react-icons/md';

import { toast } from 'react-toastify';
import Modal from '../Modal/Index';
import { IoClose } from 'react-icons/io5';
import CustomSelect from 'components/custom-select';
import { ineligibleIdsArray } from 'services/utils';
import { AiOutlineEdit } from 'react-icons/ai';
import TextEditor from 'components/text-editor';
import { useModal } from 'context/ModalContext';
import { useHelp } from 'context/HelpContext';
import { getPerformanceCategory } from 'utils/helpers';

import './style.scss';
import FeedbackImg from 'assets/img/comportamento/bg-feedback-moedas.png';
import { getNecs, getUors, getDemandantes } from 'services/realizacao.service';
import ModalAcessivel from 'components/modal-acessivel';
import { pushPlayerAction, actionLog } from 'services/actionlog.service';

const maskTemplate = 'F9999999';

// Flag para controlar se os dados foram carregados de uma task parcial
let isLoadingPartialTask = false;

export default function MissaoDestaqueCreate() {
  const navigate = useNavigate();
  const params = useParams();

  const { user, userInfo, refreshUser, currentCycle, cycles } = useAuth();
  const { helpData } = useHelp();

  const [intervalId, setIntervalId] = useState<any>(null);

  const searchRef = useRef<any>();
  const messageRef = useRef<any>();
  const titleRef = useRef<any>();
  const periodStartRef = useRef<any>();
  const periodEndRef = useRef<any>();
  const savePartialTaskTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const [isOpen, setIsOpen] = useState(true);
  const [editing, setEditing] = useState(true);

  const [searchResults, setSearchResults] = useState<User[]>([]);
  const [target, setTarget] = useState<User[]>();
  const [bkpTarget, setbkpTarget] = useState<User[]>();
  const [openTargetAlert, setOpenTargetAlert] = useState(false);
  const { showModal } = useModal();
  const [showModalTutorial, setshowModalTutorial] = useState(false);

  const [necsList, setNecsList] = useState<any>([]);
  const [demandanteList, setDemandanteList] = useState<any>([]);
  const [needNec, setNeedNec] = useState<any>([]);
  const [isEmpty, setIsEmpty] = useState(false);
  const [isEmptyName, setIsEmptyName] = useState(false);
  const [isAlreadySelectedInList, setIsAlreadySelectedInList] = useState(false);
  const [showDemandante, setShowDemandante] = useState(false);
  const [necIsSearched, setNecIsSearched] = useState(false);
  const [demandanteValue, setDemandanteValue] = useState<any>([]);
  const [selectedNec, setSelectedNec] = useState<any>([]);

  const [teamDistribution, setTeamDistribution] = useState<any>({});

  const [periodStart, setPeriodStart] = useState<any>();
  const [periodEnd, setPeriodEnd] = useState<any>();
  const [nec, setNec] = useState<any>();

  const [title, setTitle] = useState<string>();
  const [titleLength, setTitleLength] = useState<{ textLength: number; fullLength: number } | undefined>();

  const [message, setMessage] = useState<string>();
  const [messageLength, setMessageLength] = useState<{ textLength: number; fullLength: number } | undefined>();

  const [resultMessage, setResultMessage] = useState<string>();
  const [resultLength, setResultLength] = useState<{ textLength: number; fullLength: number } | undefined>();

  const [indicator, setIndicator] = useState<{ label: string; value: number | string } | undefined>();
  const [indicatorsList, setIndicatorsList] = useState<LinkedIndicators_Indicadores[] | undefined>();

  const [searchingCurrentUser, setSearchingCurrentUser] = useState(false);
  const [searching, setSearching] = useState(false);
  const [loading, setLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const [step, setStep] = useState(0);

  const [submitError, setSubmitError] = useState<string>();

  const [mask, setMask] = useState('');

  const [showModalAlert, setShowModalAlert] = useState<any>(false);

  const [currentTask, setCurrentTask] = useState<any>();
  const [maxMembersWithoutApproval, setMaxMembersWithoutApproval] = useState<number>(20);
  const [maxMembers, setMaxMembers] = useState<number | undefined>();

  const [initialManager, setInitialManager] = useState<any>();
  const [searchManager, setSearchManager] = useState<string>('');
  const [searchResultsManager, setSearchResultsManager] = useState<User[]>([]);

  const [minDate, setMinDate] = useState<string>();
  const [maxDate, setMaxDate] = useState<string>();
  const [ariaLabel, setAriaLabel] = useState('');

  const [hasOtherType, setHasOtherType] = useState(false);

  const modalRef = useRef<HTMLDivElement>(null);
  const lastFocusedElementRef = useRef<HTMLElement | null>(null);

  const [usersNotification, setUsersNotification] = useState<string[]>([]);
  const [usersNotificationPreference, setUsersNotificationPreference] = useState<string[]>([]);

  ReactModal.setAppElement('#modal');

  const minTitleLength = 0;
  const maxTitleLength = 150;

  const minMessageLength = 0;
  const maxMessageLength = 600;

  const minResultLength = 0;
  const maxResultLength = 600;

  const minMessageTarget = 60;
  const maxMessageTarget = 200;

  ReactModal.setAppElement('#modal');

  const maxMembersByProfile = useMemo(() => {
    let maxM = 0;

    if (
      !!userInfo?.ro?.match(/(3GUE|2GUT|2GCA|2GUA)/gi) &&
      (typeof maxMembers !== 'number' || (typeof maxMembers === 'number' && maxMembers <= 30))
    ) {
      maxM = 30;
    } else if (
      !!userInfo?.ro?.match(/(2GUE|1GUT|1GUA|1GCA)/gi) &&
      (typeof maxMembers !== 'number' || (typeof maxMembers === 'number' && maxMembers <= 50))
    ) {
      maxM = 50;
    } else if (
      !![3003, 4005, 4007].includes(userInfo?.cod_funcao || 0) &&
      (typeof maxMembers !== 'number' || (typeof maxMembers === 'number' && maxMembers <= 100))
    ) {
      maxM = 100;
    } else if (!![3002].includes(userInfo?.cod_funcao || 0)) {
      maxM = 1000000;
    } else {
      if (typeof maxMembers === 'number') {
        maxM = maxMembers;
      } else {
        maxM = maxMembersWithoutApproval;
      }
    }

    return maxM;
  }, [maxMembers, maxMembersWithoutApproval, userInfo]);

  const teamApproval = () => {
    const obj = {
      showAlert: false,
      showPending: false,
      isApproved: false,
      blockAdd: false,
      expired: false,
      rejected: false,
      taskStep: cycles?.find(x => {
        if (!!currentTask?._id) {
          return currentTask.created >= x.date_start && currentTask.created <= x.date_finish;
        } else {
          const date = +new Date();
          return date >= x.date_start && date <= x.date_finish;
        }
      }),
    };

    if (!!cycles && !!userInfo) {
      if (params?.id && params.id === 'cadastrar' && Array.isArray(target) && target.length > maxMembersWithoutApproval) {
        obj.showAlert = true;
      } else if (params?.id && params.id !== 'cadastrar') {
        if (!!currentTask?._id) {
          const timestamp = +new Date();
          const evaluationActive =
            !!obj.taskStep &&
            (obj.taskStep?.status === 'evaluation' ||
              (timestamp >= obj.taskStep.date_evaluation_step2_start && timestamp <= obj.taskStep.date_evaluation_step2_finish) ||
              (timestamp >= obj.taskStep.date_evaluation_step4_start && timestamp <= obj.taskStep.date_evaluation_step4_finish) ||
              (timestamp >= obj.taskStep.date_evaluation_step5_start && timestamp <= obj.taskStep.date_evaluation_step5_finish));

          if (obj.taskStep?.status === 'open') {
            if (Array.isArray(target) && target.length > maxMembersWithoutApproval) {
              obj.showAlert = true;
            }

            if (currentTask.participants_approval?.status === 'pending') {
              obj.showPending = true;
            }

            if (currentTask.participants_approval?.status === 'approved') {
              obj.isApproved = true;
            }

            if (currentTask.participants_approval?.status === 'rejected') {
              obj.rejected = true;
            }
          } else if (evaluationActive) {
            if (currentTask.participants_approval?.status === 'pending') {
              // obj.blockAdd = !!(Array.isArray(target) && target.length >= maxMembersWithoutApproval);
              obj.expired = true;
            } else if (currentTask.participants_approval?.status === 'approved') {
              obj.isApproved = true;
              // obj.blockAdd = !!(!maxMembers || (maxMembers && target?.length && target.length >= maxMembers));
            } else {
              // if (typeof maxMembers === 'number') {
              //   obj.blockAdd = !!(Array.isArray(target) && target.length >= maxMembers);
              // } else {
              //   obj.blockAdd = !!(Array.isArray(target) && target.length >= maxMembersWithoutApproval);
              // }
            }

            obj.blockAdd = !!(Array.isArray(target) && target.length >= maxMembersByProfile);

            if (currentTask.participants_approval?.status === 'rejected') {
              obj.rejected = true;
            }
          } else {
            obj.blockAdd = true;
          }
        } else {
          obj.blockAdd = true;
        }
      }
    } else {
      obj.blockAdd = true;
    }

    return obj;
  };

  function formatTeamMemberErrorMessage(teamMemberError: any[]) {
    if (!Array.isArray(teamMemberError) || !teamMemberError.length) {
      return '';
    }

    const ids = teamMemberError.map(item => item._id),
      baseMessage = 'não podem ser adicionadas porque atingiram o limite de participações nesta fase.';

    if (ids.length === 1) {
      return `A matrícula ${ids[0]} não pode ser adicionada porque atingiu o limite de participações nesta fase.`;
    }

    const lastId = ids.pop();
    const joinedIds = ids.join(', ');

    return `As matrículas ${joinedIds} e ${lastId} ${baseMessage}`;
  }

  function handleChange() {
    if (searchRef.current) {
      const value = searchRef.current.value.toUpperCase();
      if (value.length > 1) {
        if (value[0].toUpperCase() === 'F' && !isNaN(value[1])) {
          setMask(maskTemplate);
        } else {
          setMask('');
          if (value === '_______') {
            searchRef.current.value = '';
          }
        }
      } else {
        setMask('');
      }
    }
  }

  async function handleSearch(e?: any) {
    if (e) {
      e.preventDefault();
    }

    sendPartialLog({ type: 'search', data: searchRef?.current?.value });

    try {
      setOpenTargetAlert(false);
      const matricula = searchRef.current.value.replace('_', '');

      const targetOnList = target?.find(item => item._id === matricula);

      if (targetOnList) {
        setIsAlreadySelectedInList(true);
        setSearching(false);
        return;
      }

      setSearching(true);

      const stageId =
        currentTask && currentTask.created
          ? cycles?.find(x => currentTask.created >= x.date_start && currentTask.created <= x.date_finish)?._id
          : currentCycle?._id;

      const result = await findPlayer(searchRef.current.value, true, true, true, false, stageId);

      const filteredResults = result.filter((item: any) => item._id !== user?._id);
      const isCurrentUser = result.filter((item: any) => item._id === user?._id);

      if (filteredResults) {
        setSearchResults(filteredResults);

        setIsEmpty(filteredResults?.length === 0 && matricula.startsWith('F') && matricula.length === 8);
        setIsEmptyName(filteredResults?.length === 0 && isCurrentUser.length === 0);
      }

      setSearching(false);
    } catch (e) {
      setSearching(false);
    }
  }

  async function handleSearchManager(e?: any) {
    if (e) {
      e.preventDefault();
    }

    sendPartialLog({ type: 'searchManager', data: searchManager });

    try {
      setSearching(true);

      const result = await findManagers(searchManager, [1, 2, 3], true);

      const filteredResults = result.filter((item: any) => item._id !== user?._id);

      setSearchResultsManager(filteredResults);

      setSearching(false);
    } catch (e) {
      setSearching(false);
    }
  }

  function sendPartialLog(action: any) {
    try {
      const obj = {
        action: !!action ? action : 'ND',
        title: !!title ? title : 'ND',
        loading: !!loading,
        step: !!step ? step : 'ND',
        team:
          Array.isArray(target) && target.length
            ? target.map(item => {
                return {
                  _id: item._id,
                  cad_missao: item.extra?.cad_missao,
                  cod_etapa: item.extra?.cod_etapa,
                  funcao_localizacao: item.extra?.funcao_localizacao,
                  message: item.message,
                };
              })
            : 'ND',
        currentTask: !!currentTask ? currentTask : 'ND',
        stage: {
          status: currentCycle && currentCycle.status ? currentCycle?.status : 'ND',
          date_start:
            currentCycle && currentCycle.date_start
              ? typeof currentCycle.date_start === 'number'
                ? { $date: currentCycle.date_start }
                : currentCycle.date_start
              : 'ND',
          date_finish:
            currentCycle && currentCycle.date_finish
              ? typeof currentCycle.date_finish === 'number'
                ? { $date: currentCycle.date_finish }
                : currentCycle.date_finish
              : 'ND',
        },
        start: !!periodStart ? { $date: new Date(periodStart).getTime() } : 'ND',
        end: !!periodEnd ? { $date: new Date(periodEnd).getTime() } : 'ND',
        nec: !!selectedNec ? selectedNec.value : 'ND',
        indicator: !!indicator
          ? {
              nome: indicator?.label || undefined,
              cod: indicator?.value || undefined,
            }
          : 'ND',
        description: !!message ? message : 'ND',
        result: !!resultMessage ? resultMessage : 'ND',
        original_manager: !!initialManager ? initialManager._id : 'ND',
      };

      if (obj.currentTask?._id) {
        delete obj.currentTask.target;
        delete obj.currentTask.evaluator_detail;
        delete obj.currentTask.non_evaluator_detail;
        delete obj.currentTask.owner_name;
        delete obj.currentTask.owner_nome_dependencia;
        delete obj.currentTask.owner_funcao;
        delete obj.currentTask.owner_tipo_classificacao;
        delete obj.currentTask.owner_avatar;
        delete obj.currentTask.original_manager_detail;
        delete obj.currentTask.gestores;
        delete obj.currentTask.feedback;
        delete obj.currentTask.now;
        delete obj.currentTask.answeredQuiz;
        delete obj.currentTask.mad_manager_appreciated;
      }

      pushPlayerAction('partialTask', {
        data: obj,
      });
    } catch (error) {}
  }

  // Tipo para os campos que podem ser atualizados
  type PartialTaskUpdate = {
    target?: User[];
    teamDistribution?: any;
    title?: string;
    indicator?: { label: string; value: number | string };
    periodStart?: string;
    periodEnd?: string;
    selectedNec?: any;
    demandanteValue?: any;
    initialManager?: any;
    message?: string;
    resultMessage?: string;
    step?: number;
  };

  async function savePartialTask(updates?: PartialTaskUpdate) {
    if (isLoadingPartialTask || (params?.id && params.id !== 'cadastrar')) {
      return;
    }

    try {
      // Usar valores passados como parâmetro (frescos) ou do estado
      const currentTarget = updates?.target !== undefined ? updates.target : target;
      const currentTeamDistribution = updates?.teamDistribution !== undefined ? updates.teamDistribution : teamDistribution;
      const currentTitle = updates?.title !== undefined ? updates.title : title;
      const currentIndicator = updates?.indicator !== undefined ? updates.indicator : indicator;
      const currentPeriodStart = updates?.periodStart !== undefined ? updates.periodStart : periodStart;
      const currentPeriodEnd = updates?.periodEnd !== undefined ? updates.periodEnd : periodEnd;
      const currentSelectedNec = updates?.selectedNec !== undefined ? updates.selectedNec : selectedNec;
      const currentDemandanteValue = updates?.demandanteValue !== undefined ? updates.demandanteValue : demandanteValue;
      const currentInitialManager = updates?.initialManager !== undefined ? updates.initialManager : initialManager;
      const currentMessage = updates?.message !== undefined ? updates.message : message;
      const currentResultMessage = updates?.resultMessage !== undefined ? updates.resultMessage : resultMessage;
      const currentStep = updates?.step !== undefined ? updates.step : step;

      const partialTeam =
        Array.isArray(currentTarget) && currentTarget.length
          ? currentTarget.map(item => {
              return {
                _id: item._id,
                cad_missao: item.extra?.cad_missao,
                cod_etapa: item.extra?.cod_etapa,
                funcao_localizacao: item.extra?.funcao_localizacao,
                message: item.message,
                percent: currentTeamDistribution?.[item._id] || undefined,
              };
            })
          : undefined;

      const partialTask: any = {
        step: currentStep,
      };

      // Step 0 data
      if (partialTeam && partialTeam.length > 0) {
        partialTask.team = partialTeam;
      }

      // Step 1 data
      if (currentTitle) {
        partialTask.title = currentTitle;
      }

      if (currentIndicator?.label && currentIndicator?.value) {
        partialTask.indicator = {
          nome: currentIndicator.label,
          cod: currentIndicator.value,
        };
      }

      if (currentPeriodStart) {
        partialTask.start = { $date: new Date(currentPeriodStart).getTime() };
      }

      if (currentPeriodEnd) {
        partialTask.end = { $date: new Date(currentPeriodEnd).getTime() };
      }

      if (currentSelectedNec?.value) {
        partialTask.nec = currentSelectedNec.value;
      }

      if (currentDemandanteValue) {
        partialTask.demandante =
          typeof currentDemandanteValue === 'object' ? currentDemandanteValue.value : currentDemandanteValue;
      }

      if (currentInitialManager?._id) {
        partialTask.original_manager = currentInitialManager._id;
      }

      // Step 2 data
      if (currentMessage) {
        partialTask.description = currentMessage;
      }

      if (currentResultMessage) {
        partialTask.result = currentResultMessage;
      }

      await sendPartialTask(Object.keys(partialTask).length > 1 ? partialTask : null);
    } catch (error) {
      console.error('Erro ao salvar task parcial:', error);
    }
  }

  // Função com debounce para campos de texto (evita envios excessivos durante digitação)
  function debouncedSavePartialTask(updates?: PartialTaskUpdate, delay = 1500) {
    // Cancela o timer anterior se existir
    if (savePartialTaskTimerRef.current) {
      clearTimeout(savePartialTaskTimerRef.current);
    }

    // Agenda novo envio após o delay
    savePartialTaskTimerRef.current = setTimeout(() => {
      savePartialTask(updates);
      savePartialTaskTimerRef.current = null;
    }, delay);
  }

  async function handleSubmit() {
    sendPartialLog({ type: 'handleSubmit' });

    // Cancela qualquer timer de salvamento parcial pendente para evitar que seja salvo após o submit
    if (savePartialTaskTimerRef.current) {
      clearTimeout(savePartialTaskTimerRef.current);
      savePartialTaskTimerRef.current = null;
    }

    try {
      if (
        loading ||
        !message ||
        !resultMessage ||
        !userInfo ||
        !titleLength ||
        titleLength?.textLength < minTitleLength ||
        titleLength?.fullLength > maxTitleLength ||
        !messageLength ||
        messageLength?.textLength < minMessageLength ||
        messageLength?.fullLength > maxMessageLength
      )
        return;

      setLoading(true);

      let team: any = [];
      setbkpTarget(target);

      if (target) {
        team =
          target.map(item => {
            return {
              _id: item._id,
              cad_missao: item.extra?.cad_missao,
              cod_etapa: item.extra?.cod_etapa,
              funcao_localizacao: item.extra?.funcao_localizacao,
              message: item.message,
            };
          }) || [];
      }

      team = validateDistribution(team);

      // const managerOnTeam = await checkManagerOnTeam(
      //   params.id && params.id !== 'cadastrar' ? currentTask.owner : user?._id,
      //   team.map((x: { _id: any }) => x._id),
      // );

      if (params.id && params.id !== 'cadastrar') {
        const actualTask = { ...currentTask };

        if (actualTask.status === 'rejeitado' && !!actualTask?.feedback?.length) {
          deleteMissionFeedback(actualTask._id);
        }

        team.forEach((obj: any) => {
          const currentTaskTeamUser = actualTask.team.find((x: { _id: any }) => x._id === obj._id);

          if (!!currentTaskTeamUser) {
            if (currentTaskTeamUser.cad_missao) {
              obj.cad_missao = currentTaskTeamUser.cad_missao;
            }

            if (currentTaskTeamUser.cod_etapa) {
              obj.cod_etapa = currentTaskTeamUser.cod_etapa;
            }

            if (currentTaskTeamUser.funcao_localizacao) {
              obj.funcao_localizacao = currentTaskTeamUser.funcao_localizacao;
            }
          }
        });

        // team.forEach((obj: any) => {
        //   const currentTaskTeamUser = currentTask.team.find((x: { _id: any }) => x._id === obj._id);

        //   if (!!currentTaskTeamUser?.requiresApproval) {
        //     obj.requiresApproval = currentTaskTeamUser.requiresApproval;

        //     if (typeof currentTaskTeamUser.approvedByManager !== 'undefined') {
        //       obj.approvedByManager = currentTaskTeamUser.approvedByManager;
        //     }
        //   } else {
        //     const managerOnTeamUser = managerOnTeam?.find(x => x.chave === obj._id);

        //     if (!!managerOnTeamUser && !!managerOnTeamUser.requiresApproval) {
        //       obj.requiresApproval = true;
        //     }
        //   }
        // });

        const taskStep = teamApproval().taskStep;
        const totalParticipantes = team?.length;
        const participants_approval: any = {
          total: totalParticipantes,
        };

        if (teamApproval().isApproved && maxMembers) {
          if (taskStep?.status === 'open') {
            if (totalParticipantes > maxMembers) {
              delete actualTask.maxPlayersNumber;

              if (totalParticipantes >= 21 && totalParticipantes <= 30) {
                // Autorização por RO 3GUE, 2GUT, 2GCA, 2GUA
                participants_approval.status = 'pending';
                participants_approval.type = 'ro';
                participants_approval.values = '3GUE,2GUT,2GCA,2GUA,2GUE,1GUT,1GUA,1GCA,3003,4005,4007,3002';
              } else if (totalParticipantes >= 31 && totalParticipantes <= 50) {
                // Autorização por RO 2GUE, 1GUT, 1GUA ou 1GCA
                participants_approval.status = 'pending';
                participants_approval.type = 'ro';
                participants_approval.values = '2GUE,1GUT,1GUA,1GCA,3003,4005,4007,3002';
              } else if (totalParticipantes >= 51 && totalParticipantes <= 100) {
                // Autorização por Diretor ou Gerente Geral UE
                participants_approval.status = 'pending';
                participants_approval.type = 'cod_funcao';
                participants_approval.values = '3003,4005,4007,3002';
              } else if (totalParticipantes > 100) {
                // Autorização por Vice-Presidente.
                participants_approval.status = 'pending';
                participants_approval.type = 'cod_funcao';
                participants_approval.values = '3002';
              }
            }
          } else {
            if (totalParticipantes > maxMembersByProfile) {
              setLoading(false);

              return toast.error(`Você não pode inserir mais de ${maxMembersByProfile} participantes nessa realização.`, {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }

            if (actualTask?.participants_approval?.status) {
              participants_approval.status = actualTask?.participants_approval?.status;
            }

            if (actualTask?.participants_approval?.type) {
              participants_approval.type = actualTask?.participants_approval?.type;
            }

            if (actualTask?.participants_approval?.values) {
              participants_approval.values = actualTask?.participants_approval?.values;
            }
          }
        } else {
          if (taskStep?.status === 'open') {
            delete actualTask.maxPlayersNumber;

            if (totalParticipantes <= maxMembersWithoutApproval) {
              participants_approval.status = 'autoApproved';
            } else if (totalParticipantes >= 21 && totalParticipantes <= 30) {
              // Autorização por RO 3GUE, 2GUT, 2GCA, 2GUA
              participants_approval.status = 'pending';
              participants_approval.type = 'ro';
              participants_approval.values = '3GUE,2GUT,2GCA,2GUA,2GUE,1GUT,1GUA,1GCA,3003,4005,4007,3002';
            } else if (totalParticipantes >= 31 && totalParticipantes <= 50) {
              // Autorização por RO 2GUE, 1GUT, 1GUA ou 1GCA
              participants_approval.status = 'pending';
              participants_approval.type = 'ro';
              participants_approval.values = '2GUE,1GUT,1GUA,1GCA,3003,4005,4007,3002';
            } else if (totalParticipantes >= 51 && totalParticipantes <= 100) {
              // Autorização por Diretor ou Gerente Geral UE
              participants_approval.status = 'pending';
              participants_approval.type = 'cod_funcao';
              participants_approval.values = '3003,4005,4007,3002';
            } else if (totalParticipantes > 100) {
              // Autorização por Vice-Presidente.
              participants_approval.status = 'pending';
              participants_approval.type = 'cod_funcao';
              participants_approval.values = '3002';
            }
          } else {
            if (totalParticipantes > maxMembersByProfile) {
              setLoading(false);

              return toast.error(`Você não pode inserir mais de ${maxMembersByProfile} participantes nessa realização.`, {
                position: 'top-right',
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }

            participants_approval.status = 'autoApproved';
          }
        }

        const data = await updateTask({
          ...actualTask,
          team,
          title,
          indicator: {
            nome: indicator?.label || undefined,
            cod: indicator?.value || undefined,
          },
          start: { $date: new Date(periodStart).getTime() },
          end: { $date: new Date(periodEnd).getTime() },
          nec: selectedNec?.value,
          description: message,
          status: userInfo.cod_etapa > 0 ? actualTask.status : 'aguardando',
          original_manager: initialManager._id,
          result: resultMessage,
          participants_approval,
        });

        if (Array.isArray(data?.teamMemberError) && data?.teamMemberError.length) {
          setSubmitError(formatTeamMemberErrorMessage(data.teamMemberError));
        } else if (data?.teamMemberError) {
          setSubmitError(data.teamMemberError);
        }

        if (usersNotification?.length) {
          usersNotification.forEach((userId: string) => {
            const payload = {
              target: userId,
              user: userInfo?.chave,
              fase: currentCycle?._id,
              taskId: actualTask._id,
              created: { $date: new Date().getTime() },
            };

            sendNotificationTask(payload);
          });
        }
      } else {
        const serverTime = await getServerTime();

        if (
          !currentCycle?.status ||
          currentCycle.status !== 'open' ||
          serverTime > currentCycle.date_finish ||
          serverTime < currentCycle.date_start
        ) {
          return toast.error(`Não há fase disponível para envio de realizações.`, {
            position: 'top-right',
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }

        const data = await submitTask({
          owner: user?._id,
          owner_cad_missao: userInfo?.cad_missao,
          owner_cod_etapa: userInfo?.cod_etapa,
          owner_funcao_localizacao: userInfo?.funcao_localizacao,
          team,
          start: { $date: new Date(periodStart).getTime() },
          end: { $date: new Date(periodEnd).getTime() },
          nec: selectedNec.value,
          title,
          indicator: {
            nome: indicator?.label || undefined,
            cod: indicator?.value || undefined,
          },
          description: message,
          status: 'aguardando',
          original_manager: initialManager._id,
          result: resultMessage,
        });

        if (!data._id && data?.message) {
          setSubmitError(data.message);
        } else if (Array.isArray(data?.teamMemberError) && data?.teamMemberError.length) {
          setSubmitError(formatTeamMemberErrorMessage(data.teamMemberError));
        } else if (data?.teamMemberError) {
          setSubmitError(data.teamMemberError);
        } else {
          if (usersNotification?.length) {
            usersNotification.forEach((userId: string) => {
              const payload = {
                target: userId,
                user: userInfo?.chave,
                fase: currentCycle?._id,
                taskId: data._id,
                created: { $date: new Date().getTime() },
              };

              sendNotificationTask(payload);
            });
          }
        }
      }

      setLoading(false);
      setSubmitted(true);
      refreshUser();

      window.localStorage.removeItem('partialTaskMinimized');
    } catch (e) {
      setLoading(false);
    }
  }

  function removerTagsP(texto: string): string {
    const regex = /<p[^>]*>|<\/p>|\n|&nbsp;/gi;
    const textoSemTagsP = texto.replace(regex, '');

    return textoSemTagsP;
  }

  function removeTarget(index: number) {
    if (target && target.length) {
      const newTargetList = [...target];
      newTargetList.splice(index, 1);
      setTarget(newTargetList);

      // Salva log parcial após remover um membro da equipe
      savePartialTask({ target: newTargetList });
    }
  }

  const extractKeys = (data: any) => {
    const keys = [];

    if (data) {
      keys.push(data.chave);

      Object.keys(data).forEach(key => {
        if (key.startsWith('gestor') && key !== 'gestor1') {
          keys.push(data[key].chave);
        }
      });
    }

    return keys;
  };

  function changeManager(item: User) {
    if (userInfo?.mad_dupla && Array.isArray(userInfo?.mad_dupla) && userInfo?.mad_dupla?.find((e: any) => e._id === item._id)) {
      setShowModalAlert('Esse Gestor não pode ser indicado porque ele já faz parte da Dupla Liderança.');

      sendPartialLog({
        type: 'setInitialManager',
        data: item._id || 'ND',
      });

      return;
    }

    sendPartialLog({
      type: 'setInitialManager',
      data: item._id || 'ND',
    });

    setInitialManager(item);
    setSearchResultsManager([]);
    setSearchManager('');

    // Salva log parcial após alterar o gestor responsável
    savePartialTask({ initialManager: item });
  }

  async function addTarget(item: User) {
    const isOnTarget = target?.find((e: User) => e._id === item._id);

    if (
      item?.extra?.grupo === 'LIDERANCA ESTRATEGICA' ||
      item?.extra?.grupo === 'CONSELHO DIRETOR E AUDITOR GERAL' ||
      item?.extra?.grupo === 'CONSELHO DIRETOR/GG UE/AUDITOR GERAL'
    ) {
      setShowModalAlert(
        'Conforme o regulamento: Membros do Conselho Diretor, Diretores e Lideranças Estratégicas não participam da Dinâmica Realização Destaque.',
      );
      return;
    }

    focusOnElement('.currentAction input');

    if (!!isOnTarget) {
      setShowModalAlert('Este funcionário já está na lista de participantes da Realização.');
      return;
    }

    if (item?.extra?.tipo_de_acordo === 'PREDEFINIDO') {
      setShowModalAlert(
        'Conforme o regulamento, somente funcionários com Acordo de Trabalho do tipo híbrido podem ser incluídos na Realização.',
      );
      return;
    }

    const isInvalided = userInfo?.gestores?.find((e: string) => e === item._id);

    const gestoresByOwner = extractKeys(currentTask?.gestores);
    const isInvalidedByOwner = gestoresByOwner.find((e: string) => e === item._id);

    // const stage = cycles?.find(x => {
    //   if (!!currentTask?._id) {
    //     return currentTask.created >= x.date_start && currentTask.created <= x.date_finish;
    //   } else {
    //     return x._id === currentCycle?._id;
    //   }
    // });

    // const totalTaskParticipationMember = await CheckTotalTasksParticipationMember(
    //   user?._id,
    //   item?._id,
    //   stage?.date_start,
    //   stage?.date_finish,
    // );

    // const userPlayerInfo = await getPlayerInfo(item?._id);
    // const maxMemberPermited = userPlayerInfo?.is_manager ? 5 : 8;
    // const maxMember = totalTaskParticipationMember.length >= maxMemberPermited;

    // if (!!maxMember) {
    //   setShowModalAlert(
    //     'Este funcionário não pode ser adicionado a esta Realização, pois já está participando do número máximo de Realizações na fase.',
    //   );
    //   return;
    // }

    const ineligible = ineligibleIdsArray.find(e => e === item?.extra?.cod_funcao);

    if (!!isInvalided || !!isInvalidedByOwner) {
      setShowModalAlert(
        'Esta pessoa não pode ser indicada nesta Realização, pois faz parte do fluxo de apreciação desta entrega.',
      );
      return;
    }

    if (!!ineligible) {
      setShowModalAlert('Esta pessoa não pode ser indicada em Realizações Destaque.');
      return;
    }

    if (!item.canAddUser) {
      if (!usersNotification || !usersNotification.length || !usersNotification?.find((e: string) => e === item._id)) {
        setUsersNotification([...usersNotification, item._id]);
      }
      setShowModalAlert(
        'Este funcionário não pode ser adicionado a esta Realização, pois já está participando do número máximo de Realizações na fase.',
      );
      return;
    }

    if (item?.extra?.task === false) {
      if (
        !usersNotificationPreference ||
        !usersNotificationPreference.length ||
        !usersNotificationPreference?.find((e: string) => e === item._id)
      ) {
        setUsersNotificationPreference([...usersNotificationPreference, item._id]);

        const payload = {
          target: item._id,
          user: userInfo?.chave,
          item: 'task',
          created: { $date: new Date().getTime() },
        };

        sendPreferenceNotification(payload);
      }
      setShowModalAlert(`${item?.extra?.nome_guerra} optou, em "Minhas Preferências", pela não participação nesta dinâmica.`);
      return;
    }

    const newTargetList = target ? [...target, item] : [item];
    setTarget(newTargetList);
    setSearchResults([]);
    setSearching(false);
    if (searchRef && searchRef.current) {
      searchRef.current.value = '';
    }
    if (teamApproval().showAlert) {
      setOpenTargetAlert(true);
    }

    // Salva log parcial após adicionar um membro à equipe
    savePartialTask({ target: newTargetList });
  }

  function reset() {
    setTarget(undefined);
    setSubmitted(false);
    setLoading(false);
    setSubmitError(undefined);
    setSearchResults([]);
    setSearching(false);
    setMessage(undefined);
    setResultMessage(undefined);
    setTitle(undefined);
    setPeriodStart(undefined);
    setPeriodEnd(undefined);
    setNec(undefined);
    setIndicator(undefined);
    setStep(0);
    setTeamDistribution(undefined);
  }

  function handleCloseModal() {
    reset();
    navigate('../', { state: { direction: 'back' } });
    // lastFocusedElementRef.current?.focus();
    // document.removeEventListener('keydown', trapFocus);
  }

  const handleDemandanteChange = (e: any) => {
    if (selectedNec.value.cd_alcc === '123456789') {
      setDemandanteValue(e);
      selectedNec.value.nm_uor_sltt = e.value;
    }

    // Salva log parcial após alterar o demandante
    savePartialTask({ demandanteValue: e });
  };

  function validateInput(e: any) {
    if (e.value > 100) {
      e.value = 100;
    } else if (e.value < 0) {
      e.value = 0;
    } else if (e.value === '') {
      e.value = 0;
    }

    const teamMember = e.id.replace('team_player_', '');
    const newTeamDistribution = { ...teamDistribution, [teamMember]: e.value };

    setTeamDistribution(newTeamDistribution);

    // Salva log parcial após alterar o percentual de participação (com debounce para evitar envios durante digitação)
    debouncedSavePartialTask({ teamDistribution: newTeamDistribution });
  }

  const isValidDistribution: boolean = useMemo((): boolean => {
    if (!target?.length || !Object.keys(teamDistribution).length) return false;

    for (let index = 0; index < target.length; index++) {
      const teamItem = teamDistribution[target[index]._id];

      if (!teamItem || isNaN(Number(teamItem)) || Number(teamItem) <= 0) {
        return false;
      }
    }

    return true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, teamDistribution, searchResults]);

  const isValidDistributionMessage: {
    valid: boolean;
    hasFieldsEmpty: boolean;
    enteredMinimum: boolean;
    exceededMaximum: boolean;
  } = useMemo((): {
    valid: boolean;
    hasFieldsEmpty: boolean;
    enteredMinimum: boolean;
    exceededMaximum: boolean;
  } => {
    if (!target?.length) {
      return { valid: false, hasFieldsEmpty: true, enteredMinimum: false, exceededMaximum: false };
    }

    let obj: any = { valid: true, hasFieldsEmpty: false, enteredMinimum: true, exceededMaximum: false };

    for (let index = 0; index < target.length; index++) {
      const teamItem = target[index];

      if (
        typeof teamItem.message !== 'string' ||
        !teamItem.message ||
        !teamItem.message.trim().length ||
        !teamItem.messageLength ||
        teamItem.messageLength?.textLength <= 0
      ) {
        obj.valid = false;
        obj.hasFieldsEmpty = true;
      }

      if (
        teamItem.messageLength &&
        (teamItem.messageLength.textLength < minMessageTarget || teamItem.messageLength.fullLength > maxMessageTarget)
      ) {
        obj.valid = false;
        obj.enteredMinimum = teamItem.messageLength.textLength >= minMessageTarget;
        obj.exceededMaximum = teamItem.messageLength.fullLength > maxMessageTarget;
      }
    }

    return obj;
  }, [target]);

  function validateDistribution(team: any) {
    if (team) {
      let valid = true;
      const updatedTeam = [...team];
      const distribution = updatedTeam.map((item: any, index: number) => {
        try {
          const teamInput: any = teamDistribution[item._id] || 0;
          if (isNaN(teamInput) || teamInput > 100 || teamInput <= 0) {
            valid = false;
          }
          return { ...item, percent: parseInt(teamInput) };
        } catch (e) {
          console.log(e);
          valid = false;
          return { ...item };
        }
      });

      if (valid) {
        return distribution;
      } else {
        return team;
      }
    } else {
      return [];
    }
  }

  function getUserDistribution(_id: string) {
    try {
      return teamDistribution[_id];
    } catch (e) {
      return 0;
    }
  }

  function handleChangeTitle(content: string, contentLength: any) {
    const newTitle = removerTagsP(content);
    setTitle(newTitle);
    setTitleLength(contentLength);

    // Salva log parcial após alterar o título (com debounce para evitar envios durante digitação)
    debouncedSavePartialTask({ title: newTitle });
  }

  function handleChangeIndicator(e: any) {
    setIndicator(e);

    // Salva log parcial após alterar o indicador
    savePartialTask({ indicator: e });
  }

  function handleChangePeriodStart(e: any) {
    const newPeriodStart = format(utcToZonedTime(e.target.value, 'GMT'), 'yyyy-MM-dd');
    setPeriodStart(newPeriodStart);

    // Salva log parcial após alterar a data de início
    savePartialTask({ periodStart: newPeriodStart });
  }

  function handleChangePeriodEnd(e: any) {
    const newPeriodEnd = format(utcToZonedTime(e.target.value, 'GMT'), 'yyyy-MM-dd');
    setPeriodEnd(newPeriodEnd);

    // Salva log parcial após alterar a data de conclusão
    savePartialTask({ periodEnd: newPeriodEnd });
  }

  function handleChangeMessage(content: string, contentLength: any) {
    const newMessage = removerTagsP(content);
    setMessage(newMessage);
    setMessageLength(contentLength);

    // Salva log parcial após alterar a descrição da realização (com debounce para evitar envios durante digitação)
    debouncedSavePartialTask({ message: newMessage });
  }

  function handleChangeResult(content: string, contentLength: any) {
    const newResultMessage = removerTagsP(content);
    setResultMessage(newResultMessage);
    setResultLength(contentLength);

    // Salva log parcial após alterar o resultado da realização (com debounce para evitar envios durante digitação)
    debouncedSavePartialTask({ resultMessage: newResultMessage });
  }

  function handleChangeMessageTarget(content: string, contentLength: any, index: number) {
    const newTarget = target ? [...target] : [];
    newTarget[index].message = content;
    newTarget[index].messageLength = contentLength;
    setTarget(newTarget);

    // Salva log parcial após alterar a descrição de atuação do membro (com debounce para evitar envios durante digitação)
    debouncedSavePartialTask({ target: newTarget });
  }

  async function loadNecs(nec?: string) {
    const necs = await getNecs(nec);
    setNecsList(necs);

    return necs;
  }

  function getPositionLabel() {
    try {
      return (
        <div className="p-1 text-left text-white text-sm font-thin">
          <p>
            Caso não exista Necessidade de TI ou Iniciativa vinculada, escreva a sequência "123456789". Será obrigatório preencher
            o campo demandante.
          </p>
        </div>
      );
    } catch (e) {
      return `---`;
    }
  }

  const defineSelectedNec = useCallback(async (result: any) => {
    if (typeof result.nec === 'string') {
      const nec = await loadNec(result.nec);
      if (nec) {
        setDemandanteValue(nec.nm_uor_sltt);
        return {
          label: nec.cd_alcc + ' - ' + nec.nm_alcc,
          value: nec,
        };
      } else {
        return {
          label: '123456789 - SEM NEC/INICIATIVA VINCULADA',
          value: { cd_alcc: '123456789', nm_alcc: 'SEM NEC/INICIATIVA VINCULADA' },
        };
      }
    } else if (result.nec) {
      return {
        label: result.nec.cd_alcc + ' - ' + result.nec.nm_alcc,
        value: result.nec,
      };
    } else {
      return undefined;
    }
  }, []);

  useEffect(() => {
    async function loadData() {
      const result = await getTaskById(params.id);

      if (result && userInfo) {
        setCurrentTask(result);
        setEditing(true);

        const resp = await getPlayerInfo('F' + result?.original_manager?.padStart(7, '0'));
        if (resp) {
          setInitialManager(resp);
        }

        if (!!result?.maxPlayersNumber) {
          setMaxMembers(result.maxPlayersNumber as number);
        }

        const listLinkedIndicators = await getLinkedIndicators(result.owner);

        if (listLinkedIndicators?.indicadores?.length) {
          setIndicatorsList(listLinkedIndicators.indicadores);
        }
        loadVerifyTask(listLinkedIndicators?.indicadores);

        const isOwnerOnTeam: any = result.team.find((item: any) => item._id === user?._id);

        if (!isOwnerOnTeam && userInfo.cad_missao > 0) {
          result.target.push({
            _id: user?._id,
            name: user?.name,
            extra: user?.extra,
          });
          result.team.push({
            _id: user?._id,
          });
        }

        const currentTeam = result.target.sort((a: any, b: any) => (a._id === user?._id ? -1 : 1)); // = result.target.filter((item:any)=>item._id !== user?._id);
        const currentDistribution = result.team.reduce((value: any, item: any) => {
          value[item._id] = item.percent;
          return value;
        }, {});

        currentTeam.map((item: any) => {
          item.message = result?.team?.find((x: any) => x._id === item._id)?.message;
          return item;
        });

        setTarget(currentTeam);
        setTeamDistribution(currentDistribution);
        setMessage(result.description);
        setResultMessage(result.result);
        setTitle(result.title);
        setDemandanteValue(
          result.nec && result.nec.cd_alcc === '123456789'
            ? {
                label: result.nec.nm_uor_sltt,
                value: result.nec.nm_uor_sltt,
              }
            : result.nec && result.nec.cd_alcc !== '123456789'
              ? result.nec.nm_uor_sltt
              : undefined,
        );
        const selectNec = await defineSelectedNec(result);
        setSelectedNec(selectNec);
        setIndicator(
          result.indicator
            ? {
                label: result.indicator.nome,
                value: result.indicator.cod,
              }
            : undefined,
        );

        try {
          setPeriodStart(format(utcToZonedTime(result.start, 'GMT'), 'yyyy-MM-dd'));
          setPeriodEnd(format(utcToZonedTime(result.end, 'GMT'), 'yyyy-MM-dd'));
        } catch (e) {
          console.log(e);
        }

        const date = new Date(result.created);

        const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

        setMaxDate(format(lastDay, 'yyyy-MM-dd'));
        setMinDate(format(firstDay, 'yyyy-MM-dd'));
      }

      setLoading(false);
    }

    async function loadUors() {
      const uors = await getUors(userInfo?.uor_trabalho);
      setNeedNec(uors);
    }

    async function loadDemandates() {
      const demandantes = await getDemandantes();
      setDemandanteList(demandantes);
    }

    async function loadUserBySearch() {
      const listLinkedIndicators = await getLinkedIndicators();

      if (listLinkedIndicators?.indicadores?.length) {
        setIndicatorsList(listLinkedIndicators.indicadores);
      }

      loadVerifyTask(listLinkedIndicators?.indicadores);

      const currentTime = await getServerTime();

      const date = new Date(currentTime);

      const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
      const firstDay = new Date(date.getFullYear(), date.getMonth(), 1);

      setMaxDate(format(lastDay, 'yyyy-MM-dd'));
      setMinDate(format(firstDay, 'yyyy-MM-dd'));

      // Verifica se existe uma task parcial salva
      const partialTask = await getPartialTask();

      if (partialTask) {
        isLoadingPartialTask = true;

        try {
          const savedTask = partialTask;

          if (savedTask.team && Array.isArray(savedTask.team) && savedTask.team.length) {
            const teamPromises = savedTask.team.map(async (member: any) => {
              const playerData = await findPlayer(member._id, true);

              if (playerData && playerData.length) {
                const player = playerData[0];
                player.message = member.message;
                return player;
              }

              return null;
            });

            const teamResults = await Promise.all(teamPromises);
            const validTeam = teamResults.filter((member: any) => member !== null);

            if (validTeam.length) {
              setTarget(validTeam);

              const distribution: any = {};
              savedTask.team.forEach((member: any) => {
                if (member.percent) {
                  distribution[member._id] = member.percent;
                }
              });
              if (Object.keys(distribution).length) {
                setTeamDistribution(distribution);
              }
            } else {
              const result = await findPlayer(user?._id, true);
              setTarget(result);
            }
          } else {
            const result = await findPlayer(user?._id, true);
            setTarget(result);
          }

          if (savedTask.title) {
            setTitle(savedTask.title);
            setTitleLength({
              textLength: savedTask.title
                .replace(/(\n|&nbsp;)/gi, ' ')
                .replace(/\s+/gi, ' ')
                .trim().length,
              fullLength: savedTask.title
                .replace(/(\n|&nbsp;)/gi, ' ')
                .replace(/\s+/gi, ' ')
                .trim().length,
            });
          }

          if (savedTask.indicator && savedTask.indicator.cod) {
            setIndicator({
              label: savedTask.indicator.nome,
              value: savedTask.indicator.cod,
            });
          }

          if (savedTask.start) {
            try {
              setPeriodStart(format(utcToZonedTime(savedTask.start, 'GMT'), 'yyyy-MM-dd'));
            } catch (e) {
              console.log('Erro ao carregar data de início:', e);
            }
          }

          if (savedTask.end) {
            try {
              setPeriodEnd(format(utcToZonedTime(savedTask.end, 'GMT'), 'yyyy-MM-dd'));
            } catch (e) {
              console.log('Erro ao carregar data de fim:', e);
            }
          }

          if (savedTask.nec) {
            const necValue = savedTask.nec;
            setSelectedNec({
              label: necValue.cd_alcc + ' - ' + necValue.nm_alcc,
              value: necValue,
            });

            if (necValue.cd_alcc === '123456789') {
              setShowDemandante(true);
            }
          }

          if (savedTask.demandante) {
            if (savedTask.nec && savedTask.nec.cd_alcc === '123456789') {
              setDemandanteValue({
                label: savedTask.demandante,
                value: savedTask.demandante,
              });
            } else {
              setDemandanteValue(savedTask.demandante);
            }
          }

          if (savedTask.original_manager) {
            const managerData = await getPlayerInfo('F' + savedTask.original_manager.replace('F', '').padStart(7, '0'));

            if (managerData) {
              setInitialManager(managerData);
            }
          }

          if (savedTask.description) {
            setMessage(savedTask.description);
            setMessageLength({
              textLength: savedTask.description
                .replace(/(\n|&nbsp;)/gi, ' ')
                .replace(/\s+/gi, ' ')
                .trim().length,
              fullLength: savedTask.description
                .replace(/(\n|&nbsp;)/gi, ' ')
                .replace(/\s+/gi, ' ')
                .trim().length,
            });
          }

          if (savedTask.result) {
            setResultMessage(savedTask.result);
            setResultLength({
              textLength: savedTask.result
                .replace(/(\n|&nbsp;)/gi, ' ')
                .replace(/\s+/gi, ' ')
                .trim().length,
              fullLength: savedTask.result
                .replace(/(\n|&nbsp;)/gi, ' ')
                .replace(/\s+/gi, ' ')
                .trim().length,
            });
          }

          if (typeof savedTask.step === 'number' && savedTask.step > 0) {
            setStep(savedTask.step);
          }
        } catch (error) {
          console.error('Erro ao carregar task parcial:', error);
          // Em caso de erro, carrega apenas o usuário atual
          const result = await findPlayer(user?._id, true);
          setTarget(result);
        } finally {
          isLoadingPartialTask = false;
        }
      } else {
        const result = await findPlayer(user?._id, true);
        setTarget(result);

        const gestorResult = await getPlayerInfo('F' + userInfo?.gestor?.padStart(7, '0'));
        if (gestorResult) {
          setInitialManager(gestorResult);
        }
      }
    }

    async function loadVerifyTask(indicadores?: LinkedIndicators_Indicadores[]) {
      const data = await verifyTask(params.id);

      if (data && data?.total && data?.total > 0 && indicadores?.length && indicadores?.length > 1) {
        setHasOtherType(true);
      }
    }

    if (user && userInfo) {
      if (params && params.id && params.id !== 'cadastrar') {
        loadData();
      } else {
        loadUserBySearch();
      }

      loadNecs();
      loadUors();
      loadDemandates();
    }
  }, [defineSelectedNec, params, user, userInfo]);

  const periodEndIsValid: boolean = useMemo((): boolean => {
    if (
      !!periodEnd?.length &&
      // !!minDate?.length &&
      !!maxDate?.length &&
      // new Date(periodEnd) >= new Date(minDate) &&
      // new Date(periodStart) >= new Date('2024-07-01T00:00:00.000Z') &&
      new Date(periodEnd) >= new Date('2024-07-01T00:00:00.000Z') &&
      new Date(periodEnd) <= new Date(maxDate) &&
      periodStart <= periodEnd
    ) {
      return true;
    }

    return false;
  }, [periodEnd, maxDate, periodStart]);

  const loadNec = async (necId: string) => {
    let necByLoad: any = await getNecs(necId);
    return necByLoad.length > 0 ? necByLoad[0] : null;
  };

  const dotsText = [
    'Até 20: Liberação automática;',
    'De 21 a 30: 3º nível gerencial de UE ou 2º nível de UT, UA ou CA;',
    'De 31 a 50: 2º nível gerencial de UE ou 1º nível de UT, UA ou CA;',
    'De 51 a 100: Diretor ou Gerente Geral UE;',
    'Acima de 100: Vice-Presidente.',
  ];

  function textRecomendation() {
    return (
      <div className="font-normal text-sm mt-4">
        {dotsText.map((text, index) => (
          <p key={text}>
            <span className="dots">&#8226;&nbsp;</span>
            {text}
          </p>
        ))}
      </div>
    );
  }

  let searchTimer: ReturnType<typeof setTimeout>;

  const timeoutDelay = 500;

  const handleInputChange = (e: any) => {
    if (searchTimer) {
      clearTimeout(searchTimer);
    }

    searchTimer = setTimeout(() => {
      loadNecs(e);
    }, timeoutDelay);
  };
  const buttonContinueIsDisabled = () => {
    return (
      (step === 0 && (!target?.length || !isValidDistribution || !isValidDistributionMessage.valid)) ||
      (step === 1 &&
        (!title?.length ||
          !indicator ||
          !indicator?.label ||
          !indicator?.value ||
          !periodStart?.length ||
          !periodEnd?.length ||
          !periodEndIsValid ||
          !initialManager?._id ||
          new Date(periodEnd) < new Date(periodStart) ||
          !titleLength ||
          titleLength?.textLength < minTitleLength ||
          titleLength?.fullLength > maxTitleLength ||
          (hasOtherType && indicator?.value === 1) ||
          (needNec.length > 0 && (!selectedNec?.value || !demandanteValue)))) ||
      (step === 2 &&
        (!message ||
          !resultMessage ||
          !messageLength ||
          messageLength?.textLength < minMessageLength ||
          messageLength?.fullLength > maxMessageLength ||
          !resultLength ||
          resultLength?.textLength < minResultLength ||
          resultLength?.fullLength > maxResultLength))
    );
  };

  function changeValue(id: string, value: number) {
    const input: any = document.getElementById(id);
    const newValue = value;
    input.value = newValue;

    validateInput(input);
  }

  useEffect(() => {
    if (step) {
      toNextStepFocus();
    }

    setAriaLabel(`Etapa ${step + 1} de 3 para cadastrar realização destaque`);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [step]);

  // Cleanup do timer de salvamento parcial quando o componente for desmontado
  useEffect(() => {
    return () => {
      if (savePartialTaskTimerRef.current) {
        clearTimeout(savePartialTaskTimerRef.current);
        savePartialTaskTimerRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    async function playerCanView() {
      const serverTime = await getServerTime();

      if (
        !currentCycle?.status ||
        currentCycle.status !== 'open' ||
        serverTime > currentCycle.date_finish ||
        serverTime < currentCycle.date_start
      ) {
        toast.error(`Não há fase disponível para envio de realizações.`, {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });

        return navigate('../');
      }
    }

    if (!!currentCycle && params && params.id && params.id === 'cadastrar') {
      playerCanView();
    }
  }, [currentCycle, navigate, params]);

  if (!userInfo) return null;

  const handleChangeNec = (selectedOption: any) => {
    setSelectedNec(selectedOption);

    let newDemandanteValue: any;
    if (selectedOption.value.cd_alcc === '123456789') {
      setShowDemandante(true);
      setDemandanteValue('');
      newDemandanteValue = '';
    } else {
      setShowDemandante(false);
      setDemandanteValue(selectedOption.value.nm_uor_sltt);
      newDemandanteValue = selectedOption.value.nm_uor_sltt;
    }

    // Salva log parcial após alterar a NEC
    savePartialTask({ selectedNec: selectedOption, demandanteValue: newDemandanteValue });
  };

  if (
    params &&
    params.id &&
    params.id === 'cadastrar' &&
    (userInfo?.cad_missao <= 0 ||
      (Array.isArray(userInfo?.mad_dupla) &&
        userInfo?.mad_dupla?.some((md: any) => typeof md.cad_missao === 'number' && md.cad_missao <= 0)))
  ) {
    return null;
  }

  if (!!userInfo.visualizador) {
    return null;
  }

  if (currentCycle?._id === '68af4da8458e527eaa788503') {
    return null;
  }

  function focusOnElement(selector: string) {
    const element: any = document.querySelector(selector);
    if (!!element) {
      element?.focus();
    }
  }

  // function afterOpenModal() {
  //   lastFocusedElementRef.current = document.activeElement as HTMLElement;
  //   const focusableElementsString =
  //     'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex], [contenteditable]';
  //   const focusableElements = modalRef.current?.querySelectorAll(focusableElementsString);
  //   const firstFocusableElement = focusableElements ? (focusableElements[0] as HTMLElement) : null;
  //   firstFocusableElement?.focus();

  //   document.addEventListener('keydown', trapFocus);
  // }

  // function trapFocus(event: KeyboardEvent) {
  //   const focusableElementsString =
  //     'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex]:not([tabindex="-1"]), [contenteditable]';
  //   const focusableElements = modalRef.current?.querySelectorAll(focusableElementsString);
  //   if (focusableElements) {
  //     const firstFocusableElement = focusableElements[0] as HTMLElement;
  //     const lastFocusableElement = focusableElements[focusableElements.length - 1] as HTMLElement;

  //     if (event.key === 'Tab') {
  //       if (event.shiftKey) {
  //         if (document.activeElement === firstFocusableElement) {
  //           lastFocusableElement.focus();
  //           event.preventDefault();
  //         }
  //       } else {
  //         if (document.activeElement === lastFocusableElement) {
  //           firstFocusableElement.focus();
  //           event.preventDefault();
  //         }
  //       }
  //     }
  //   }
  // }

  function toNextStepFocus() {
    focusOnElement('.informativeSteps div');
  }

  if (user?.extra?.task === false) return null;

  return (
    <ReactModal
      key={'modal-create-task'}
      shouldCloseOnEsc={true}
      shouldCloseOnOverlayClick={true}
      isOpen={isOpen}
      // onAfterOpen={afterOpenModal}
      onAfterClose={handleCloseModal}
      contentLabel="Modal Entrega"
      portalClassName="modal-create-mission"
      overlayClassName="fixed z-20 top-0 left-0 w-full h-full bg-black bg-opacity-80 flex flex-col items-center justify-center"
      contentElement={() => (
        <ModalAcessivel isOpen={isOpen} onRequestClose={() => setIsOpen(false)}>
          {!submitted && (
            <Box className="relative bg-oxford-blue border-electric-blue py-8 px-5 lg:pl-16 flex flex-col w-[90%] lg:max-w-screen-md justify-center items-center border-opacity-100 bg-opacity-100">
              <button
                aria-label="Fechar modal"
                className="absolute -top-5 -right-5 button-close bg-slate-blue rounded-full p-1"
                onClick={() => {
                  if (searchResults.length > 0) {
                    sendPartialLog({ type: 'close', location: 'header', reset: true });
                    reset();
                  } else {
                    sendPartialLog({ type: 'close', location: 'header', reset: false });
                    setIsOpen(false);
                    document.dispatchEvent(new CustomEvent('reload:partialTask'));
                  }
                }}
              >
                <IoClose size={30} className="text-white" />
              </button>

              <div className="mx-auto relative container overflow-y-auto overflow-x-hidden max-h-[85vh] pr-8">
                <div className="block mb-8">
                  <h3
                    className="text-lg uppercase block text-center text-yellow"
                    tabIndex={0}
                    aria-label={`Modal  ${params.id && params.id !== 'cadastrar' ? 'Editar' : 'Cadastrar'} Realização Destaque`}
                  >
                    {params.id && params.id !== 'cadastrar' ? 'Editar' : 'Cadastrar'} Realização Destaque
                  </h3>
                </div>
                {!loading && !submitted && (
                  <div className="informativeSteps space-y-4">
                    <div className="relative flex flex-row items-center justify-around" tabIndex={0} aria-labelledby="steps">
                      <p className="hidden" id="steps">
                        {ariaLabel}
                      </p>
                      <div className="absolute z-0 w-full h-[1px] top-0 bottom-0 m-auto border-b border-white opacity-20"></div>
                      <div
                        aria-hidden={true}
                        className={`${
                          step === 0 ? 'bg-slate-blue' : 'bg-prussian-blue text-white'
                        } text-xs relative ring-1 ring-white rounded-full w-5 h-5 flex flex-row items-center justify-center`}
                      >
                        1
                      </div>
                      <div
                        aria-hidden={true}
                        className={`${
                          step === 1 ? 'bg-slate-blue' : 'bg-prussian-blue text-white'
                        } text-xs relative ring-1 ring-white rounded-full w-5 h-5 flex flex-row items-center justify-center`}
                      >
                        2
                      </div>
                      <div
                        aria-hidden={true}
                        className={`${
                          step === 2 ? 'bg-slate-blue' : 'bg-prussian-blue text-white'
                        } text-xs relative ring-1 ring-white rounded-full w-5 h-5 flex flex-row items-center justify-center`}
                      >
                        3
                      </div>
                    </div>
                    {!!helpData && (
                      <div>
                        <p>
                          Possui dúvidas ao preencher esta etapa? Confira o tutorial em vídeo.
                          <button
                            className="p-2 text-[#C2D2FF]"
                            onClick={() => showModal('help-video')}
                            aria-label="Possui dúvidas ao preencher esta etapa? Confira o tutorial em vídeo."
                          >
                            ASSISTIR VÍDEO
                          </button>
                        </p>
                      </div>
                    )}
                    {step === 0 && (
                      <div className="space-y-6">
                        <div className="space-x-4 flex flex-row items-center justify-between w-full">
                          <div className="relative flex-1">
                            <span className="text-alice-blue mb-4 block text-base font-thin" tabIndex={0}>
                              Inclua a equipe que efetivamente atuou com você para a conclusão da entrega, especificando o
                              percentual de participação do funcionário em uma escala de 25 a 100.
                            </span>
                            {!!(!target?.length || !teamApproval().blockAdd) && (
                              <div>
                                <div className="space-x-4 flex flex-row items-center justify-between">
                                  <form onSubmit={handleSearch} className="pl-1 flex-1">
                                    <InputMask
                                      placeholder="Digite o nome ou chave do funcionário"
                                      alwaysShowMask={false}
                                      mask={mask}
                                      ref={(ref: any) => {
                                        searchRef.current = ref;
                                      }}
                                      onChange={e => handleChange()}
                                      inputMode="search"
                                      style={{ fontSize: 16 }}
                                      className="w-full bg-maastricht-blue text-white text-sm font-light flex-1 rounded-md py-2 px-4"
                                      aria-label="Campo de busca. Em branco. Campo editável.
                                                  Observação: Você pode adicionar até 12 pessoas
                                                  nesta realização. Insira apenas colegas que
                                                  efetivamente participaram da entrega."
                                    />
                                  </form>

                                  <button tabIndex={0} aria-label="Buscar funcionário" onClick={() => handleSearch()}>
                                    <TbSearch size={28} className="cursor-pointer hover:ring-2 mr-1 rounded-full" />
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        {!searching && isAlreadySelectedInList && (
                          <div className="flex-1 mt-5 bg-rich-black bg-opacity-80 py-4 px-8 rounded-3xl">
                            <div className="text-center pt-2 text-white font-base font-light">
                              Esse usuário já foi inserido na lista de participantes.
                            </div>
                          </div>
                        )}

                        {!!teamApproval().showAlert && (
                          <div
                            className="bg-maastricht-blue rounded-2xl py-6 px-8 cursor-pointer"
                            onClick={() => setOpenTargetAlert(prev => !prev)}
                          >
                            <div>
                              <div className="flex flex-row items-center justify-between w-full cursor-pointer">
                                <p className="text-yellow text-base font-bold">
                                  Atenção às regras de aprovação para a quantidade de participantes
                                </p>
                                {openTargetAlert ? <MdOutlineExpandLess size={32} /> : <MdOutlineExpandMore size={32} />}
                              </div>
                              {!!openTargetAlert && <>{textRecomendation()}</>}
                            </div>
                          </div>
                        )}

                        {!!searchResults && searchResults.length > 0 && (
                          <>
                            <div className="flex-1 bg-rich-black bg-opacity-80 py-4 px-8 rounded-3xl h-[30vh] lg:h-auto overflow-y-auto lg:overflow-y-visible">
                              {searchResults.map((item, index) => (
                                <button
                                  key={item._id}
                                  onClick={() => {
                                    sendPartialLog({ type: 'addTarget', data: item._id });
                                    addTarget(item);
                                  }}
                                  aria-label={`${item.name}. Chave ${item._id}. ${
                                    item.extra?.diretoria && 'Lotado ' + item.extra?.diretoria
                                  }`}
                                  className={`cursor-pointer hover:opacity-75 w-full flex flex-row items-center justify-between border-b border-prussian-blue pb-4 mb-4 text-left`}
                                >
                                  <div className="w-[44px] h-[44px] ml-2">
                                    <UserAvatar
                                      data={{
                                        image: item.image,
                                        ...item.extra,
                                      }}
                                    />
                                  </div>
                                  <p className="flex-1 pl-3 pr-2 w-3/5">
                                    <span className="text-xs font-thin">
                                      <strong className="text-base font-semibold">{item.extra?.nome_guerra}</strong> ({item._id})
                                    </span>
                                    <span className="block text-xs font-thin">{item.name}</span>
                                    {!!item.extra?.diretoria || !!item.extra?.funcao ? (
                                      <span className="block text-xs font-thin">
                                        {!!item.extra?.diretoria && (
                                          <span className="text-electric-blue uppercase">{item.extra?.diretoria}</span>
                                        )}
                                        {!!item.extra?.diretoria && !!item.extra?.funcao && ' - '}
                                        {item.extra?.funcao ? `${item.extra?.funcao}` : ''}
                                      </span>
                                    ) : null}
                                  </p>
                                </button>
                              ))}

                              <div className="text-center pt-2 text-white font-base font-light">
                                Não encontrou quem procura? Experimente buscar por nome e sobrenome ou matrícula.
                              </div>
                            </div>
                          </>
                        )}

                        {!searching && isEmptyName && (
                          <div className="flex-1 mt-5 bg-rich-black bg-opacity-80 py-4 px-8 rounded-3xl">
                            <div className="text-center pt-2 text-white font-base font-light">
                              Não encontrou quem procura? Experimente buscar por nome e sobrenome ou matrícula.
                            </div>
                          </div>
                        )}

                        {target && target?.length > 0 && !searching && (
                          <>
                            <div>
                              {target?.length && (
                                <p
                                  className="block text-sm text-white font-bold"
                                  tabIndex={0}
                                  aria-label={`Total de participantes: ${target?.length}`}
                                >
                                  Total de participantes: {target?.length}
                                </p>
                              )}
                              <p className="text-alice-blue block text-sm font-thin" tabIndex={0}>
                                Adapte os percentuais, conforme a natureza da realização, a complexidade da atuação e as
                                expectativas específicas.
                              </p>

                              {!!teamApproval().showPending && (
                                <p className="text-yellow block text-sm font-thin">
                                  A realização está aguardando a aprovação dos participantes pela gestão.
                                </p>
                              )}
                              {!!teamApproval().isApproved && (
                                <p className="text-yellow block text-sm font-thin">
                                  A quantidade de participantes foi aprovada pela gestão.{' '}
                                  {teamApproval().taskStep?.status === 'open'
                                    ? 'Caso altere os participantes, a realização poderá passar por uma nova avaliação.'
                                    : `A realização poderá ter no máximo ${maxMembers} participantes.`}
                                </p>
                              )}
                              {(!!teamApproval().expired || !!teamApproval().rejected) && (
                                <p className="text-yellow block text-sm font-thin">
                                  A quantidade de participantes não foi aprovada pela gestão. A realização poderá ter no máximo{' '}
                                  {maxMembersWithoutApproval} participantes.
                                </p>
                              )}
                            </div>
                            <div className="flex-1 bg-rich-black bg-opacity-80 py-4 px-2 lg:px-8 rounded-3xl">
                              {target.map((item: User, index: number) => (
                                <div
                                  key={item._id}
                                  className={`w-full flex flex-col justify-between gap-4 ${
                                    index + 1 < target.length ? 'border-b border-prussian-blue pb-4 mb-4 ' : ''
                                  }`}
                                >
                                  <div className="flex flex-1 relative">
                                    <div className="flex flex-row">
                                      <div className="w-[44px] h-[44px] ml-2">
                                        <UserAvatar
                                          data={{
                                            image: item.image,
                                            ...item.extra,
                                          }}
                                        />
                                      </div>
                                      <p className="flex-1 pl-3 pr-2 max-w-xs">
                                        <span
                                          className="text-xs font-thin"
                                          tabIndex={0}
                                          aria-label={`${item.name}. chave ${item._id}`}
                                        >
                                          <strong className="text-base font-semibold truncate w-[35vw] text lg:w-auto block">
                                            {item.extra?.nome_guerra}
                                          </strong>{' '}
                                          <span className="block text-xs font-thin">{item.name}</span>
                                          {item._id}{' '}
                                          {!!item.extra?.diretoria && (
                                            <span className="text-electric-blue uppercase">- {item.extra?.diretoria}</span>
                                          )}
                                          {!!item.extra?.diretoria && !!item.extra?.funcao && ' - '}
                                          {item.extra?.funcao ? `${item.extra?.funcao}` : ''}
                                        </span>
                                      </p>
                                    </div>
                                    {user?._id !== item._id && item?._id !== currentTask?.owner && (
                                      <RiCloseLine
                                        size={44}
                                        className="cursor-pointer hover:ring-2 p-2 rounded-full text-slate-blue absolute right-0  lg:hidden"
                                        onClick={() => {
                                          sendPartialLog({ type: 'removeTarget', data: index });
                                          removeTarget(index);
                                        }}
                                      />
                                    )}
                                  </div>
                                  <div className="flex flex-col">
                                    <div className="flex flex-row justify-between">
                                      <p>Percentual de participação:</p>
                                      {user?._id !== item._id && item?._id !== currentTask?.owner && (
                                        <RiCloseLine
                                          size={24}
                                          className="cursor-pointer hover:ring-2 rounded-full text-slate-blue hidden lg:block w-[24px]"
                                          onClick={() => {
                                            sendPartialLog({ type: 'removeTarget', data: index });
                                            removeTarget(index);
                                          }}
                                        />
                                      )}
                                    </div>
                                    <input
                                      id={`team_player_${item._id}`}
                                      type="number"
                                      onChange={validateInput}
                                      placeholder="0"
                                      step="10"
                                      defaultValue={getUserDistribution(item._id)}
                                      maxLength={3}
                                      readOnly
                                      className="hidden"
                                    />
                                  </div>
                                  <div className="flex flex-row gap-3">
                                    {[25, 50, 75, 100].map(buttonValue => {
                                      return (
                                        <Tippy
                                          key={buttonValue}
                                          placement="bottom"
                                          allowHTML={true}
                                          className="bg-black"
                                          maxWidth={300}
                                          content={<div>{getPerformanceCategory(buttonValue)}</div>}
                                        >
                                          <button
                                            aria-label={`botão ${buttonValue}% ${buttonValue === Number(teamDistribution[item._id]) ? 'selecionado' : ''}`}
                                            onClick={() => {
                                              sendPartialLog({
                                                type: 'changeValue',
                                                data: { id: item._id ? `team_player_${item._id}` : 'ND', value: buttonValue },
                                              });
                                              changeValue(item._id ? `team_player_${item._id}` : '', buttonValue);
                                            }}
                                            className={`text-base leading-none disabled:opacity-50 ring-2 w-14 h-14 ring-slate-blue flex flex-col justify-center lg:flex-row items-center ${
                                              buttonValue === Number(teamDistribution[item._id])
                                                ? 'bg-slate-blue text-white'
                                                : 'bg-transparent text-white'
                                            } rounded py-1 px-1`}
                                          >
                                            {buttonValue === Number(teamDistribution[item._id]) ? buttonValue + '%' : buttonValue}
                                          </button>
                                        </Tippy>
                                      );
                                    })}
                                  </div>
                                  <div className="text-electric-blue text-xs font-thin">
                                    {teamDistribution[item._id] ? getPerformanceCategory(Number(teamDistribution[item._id])) : ''}
                                  </div>
                                  {teamDistribution[item._id] && (
                                    <div className="text-white">
                                      <p className="mb-2">Descreva a atuação desse funcionário</p>
                                      <div className="h-28 w-full bg-transparent text-xs font-thin">
                                        <TextEditor
                                          disableEmoji
                                          initialValue={item.message}
                                          maxLength={maxMessageTarget}
                                          minLength={minMessageTarget}
                                          onChange={(html, length) => handleChangeMessageTarget(html, length, index)}
                                        ></TextEditor>
                                      </div>
                                    </div>
                                  )}
                                </div>
                              ))}
                            </div>
                          </>
                        )}

                        {isEmpty && !searching && (
                          <div className="flex-1 mt-5 bg-rich-black bg-opacity-80 py-4 px-8 rounded-3xl">
                            <div className="text-center pt-2 text-white font-base font-light">
                              Verifique a matrícula que você está buscando, essa matrícula não consta na base de funcionário do
                              Joga Junto.
                            </div>
                          </div>
                        )}

                        {searching && (
                          <div className="flex-1 bg-rich-black bg-opacity-80 p-8 rounded-3xl">
                            <p className="animate-pulse text-yellow">Recuperando informações...</p>
                          </div>
                        )}

                        {target && target?.length > 0 && !isValidDistribution && (
                          <p className="block font-light text-yellow">
                            Para continuar, preencha o percentual estimado de atuação de cada membro da equipe.
                          </p>
                        )}

                        {target && target?.length > 0 && isValidDistribution && !isValidDistributionMessage.valid && (
                          <>
                            {!!isValidDistributionMessage.hasFieldsEmpty && (
                              <p className="block font-light text-yellow">
                                Para continuar, preencha o texto descrevendo a atuação de cada membro da equipe.
                              </p>
                            )}

                            {!isValidDistributionMessage.hasFieldsEmpty &&
                            typeof isValidDistributionMessage.enteredMinimum === `boolean` &&
                            !isValidDistributionMessage.enteredMinimum ? (
                              <p className="block font-light text-yellow">
                                Preencha a atuação de cada membro da equipe com no mínimo <strong>{minMessageTarget}</strong>{' '}
                                caracteres.
                              </p>
                            ) : !isValidDistributionMessage.hasFieldsEmpty && isValidDistributionMessage.exceededMaximum ? (
                              <p className="block font-light text-yellow">
                                Preencha a atuação de cada membro da equipe com no máximo <strong>{maxMessageTarget}</strong>{' '}
                                caracteres.
                              </p>
                            ) : null}
                          </>
                        )}
                      </div>
                    )}

                    {step === 1 && (
                      <>
                        <div className="border-2 border-electric-blue rounded-2xl p-8 flex flex-col w-full space-y-4 lg:space-y-6">
                          <div
                            className="text-white text-lg lg:text-lg block leading-none font-semibold"
                            tabIndex={0}
                            aria-label="Informações da entrega"
                          >
                            Informações da Realização Destaque
                          </div>

                          <div ref={ref => (titleRef.current = ref)}>
                            <label className="text-white font-thin text-xs leading-none mb-2 block">Nome da realização</label>
                            <TextEditor
                              disableEmoji
                              initialValue={title}
                              maxLength={maxTitleLength}
                              minLength={minTitleLength}
                              onChange={handleChangeTitle}
                              className="w-full text-white py-2 rounded-md leading-none text-sm font-light"
                            />
                          </div>

                          <div>
                            <label
                              tabIndex={0}
                              aria-label="Informar Indicador ligado a realização destaque. "
                              className="text-white font-thin text-xs leading-none mb-2 block"
                            >
                              Indicador
                            </label>
                            <CustomSelect
                              className="select-realizacao-destaque"
                              aria-label="Expandir caixa de seleção para mostrar opções de indicadores."
                              value={indicator}
                              placeholder="Selecione o indicador ligado a Realização Destaque"
                              options={
                                indicatorsList
                                  ? indicatorsList.map((item, index: number) => {
                                      return {
                                        label: item.nome,
                                        value: item.cod,
                                      };
                                    })
                                  : [
                                      {
                                        label: 'Sem indicador',
                                        value: '',
                                      },
                                    ]
                              }
                              onChange={handleChangeIndicator}
                            />
                          </div>

                          <div className="w-full flex flex-col lg:flex-row lg:space-x-8 space-y-4 lg:space-y-0">
                            <div className="lg:w-1/2">
                              <label
                                tabIndex={0}
                                aria-label="Informar Data de início da entrega. Em branco. Campo editável"
                                className="text-white font-thin text-xs leading-none mb-2 block"
                              >
                                Início da entrega
                              </label>
                              <input
                                type="date"
                                aria-label="Definir data de início da entrega.
                                            Abre modal com um calendário."
                                defaultValue={periodStart}
                                ref={ref => (periodStartRef.current = ref)}
                                onChange={handleChangePeriodStart}
                                className="w-full bg-maastricht-blue text-white text-sm font-light py-2 px-4 rounded-md leading-none"
                              />
                            </div>

                            <div className="lg:w-1/2">
                              <label
                                tabIndex={0}
                                aria-label="Informar Data do final da entrega. Em branco. Campo editável"
                                className="text-white font-thin text-xs leading-none mb-2 block"
                              >
                                Conclusão da Entrega
                              </label>
                              <input
                                aria-label="Definir data de início da entrega.
                                            Abre modal com um calendário."
                                defaultValue={periodEnd}
                                type="date"
                                ref={ref => (periodEndRef.current = ref)}
                                onChange={handleChangePeriodEnd}
                                className="w-full bg-maastricht-blue text-white py-2 px-4 rounded-md leading-none text-sm font-light"
                              />
                            </div>
                          </div>

                          {(needNec.length > 0 || selectedNec?.label) && (
                            <>
                              <div className="w-full flex flex-col lg:flex-row lg:space-x-8 space-y-4 lg:space-y-0">
                                <div className="lg:w-full">
                                  <div>
                                    <label
                                      tabIndex={0}
                                      aria-label="Informar Nec ou Iniciativa ligada a realização destaque."
                                      className="text-white font-thin text-xs leading-none mb-2 flex"
                                    >
                                      Número da NEC/INICIATIVA
                                      <Tippy className="drop-shadow-lg" allowHTML={true} content={getPositionLabel()}>
                                        <span className="block">
                                          <BiInfoCircle className="text-white text-base -my-1 block" />
                                        </span>
                                      </Tippy>
                                    </label>
                                    <CustomSelect
                                      onInputChange={(e: any) => handleInputChange(e)}
                                      className="select-realizacao-destaque"
                                      aria-label="Expandir caixa de seleção para mostrar opções de NECs."
                                      value={selectedNec}
                                      onBlur={() => setNecIsSearched(true)}
                                      placeholder="Selecione a NEC ou a Iniciativa ligada a Realização Destaque"
                                      options={
                                        necsList
                                          ? [
                                              ...necsList.map((item: any, index: number) => {
                                                return {
                                                  label: item.cd_alcc + ' - ' + item.nm_alcc,
                                                  value: item,
                                                };
                                              }),
                                              {
                                                label: '123456789 - SEM NEC/INICIATIVA VINCULADA',
                                                value: { cd_alcc: '123456789', nm_alcc: 'SEM NEC/INICIATIVA VINCULADA' },
                                              },
                                            ]
                                          : [
                                              {
                                                label: 'Carregando...',
                                                value: '',
                                              },
                                            ]
                                      }
                                      onChange={(e: any) => [handleChangeNec(e)]}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div>
                                <div>
                                  <label htmlFor="demandante" className="text-white font-thin text-xs leading-none mb-2 block">
                                    Demandante:
                                  </label>
                                  {selectedNec?.value && selectedNec?.value?.cd_alcc !== '123456789' ? (
                                    <input
                                      id="demandante"
                                      type="text"
                                      value={demandanteValue}
                                      onChange={handleDemandanteChange}
                                      readOnly={selectedNec?.value && selectedNec?.value?.cd_alcc !== '123456789'}
                                      className={`text-white w-full bg-maastricht-blue py-2 px-4 rounded-md leading-none text-sm font-light`}
                                    />
                                  ) : (
                                    <CustomSelect
                                      className="select-realizacao-destaque"
                                      aria-label="Expandir caixa de seleção para mostrar opções de demandantes. Recolhida."
                                      value={demandanteValue}
                                      placeholder="Selecione o demandante ligado a Realização Destaque"
                                      options={
                                        demandanteList
                                          ? demandanteList.map((item: any, index: number) => {
                                              return {
                                                label: item.nm_uor_sltt,
                                                value: item.nm_uor_sltt,
                                              };
                                            })
                                          : [
                                              {
                                                label: 'Carregando...',
                                                value: '',
                                              },
                                            ]
                                      }
                                      onChange={handleDemandanteChange}
                                    />
                                  )}
                                </div>
                              </div>
                            </>
                          )}
                          <div>
                            <label
                              className="text-white font-thin text-xs leading-none mb-2 flex items-center"
                              tabIndex={0}
                              aria-label={`Responsável pela apreciação: ${initialManager?.nome_guerra} (${initialManager?.chave}) - ${initialManager?.funcao}. Campo editável. Essa pessoa é responsável por realizar a apreciação desta entrega? Caso não seja ela, você pode alterá-la, clicando no ícone acima. Atenção: Não deve ser indicado novo líder nas situações em que o seu gestor tenha ausência temporária (férias, abonos, licença paternidade, folgas, viagem a serviço, licença saúde até 15 (quinze) dias etc.).`}
                            >
                              Responsável por apreciar a realização
                            </label>

                            <div className="flex space-x-3">
                              <form onSubmit={handleSearchManager} className="pl-1 flex-1">
                                <input
                                  value={
                                    !!initialManager && !!initialManager.nome_guerra
                                      ? `${initialManager.nome_guerra} (${initialManager.chave}) - ${initialManager.funcao}`
                                      : searchManager
                                  }
                                  disabled={!!initialManager}
                                  onChange={e => setSearchManager(e.target.value)}
                                  className={`text-white w-full bg-maastricht-blue py-2 px-4 rounded-md leading-none text-sm font-light`}
                                />
                              </form>

                              {!!initialManager ? (
                                <button
                                  onClick={() => {
                                    sendPartialLog({
                                      type: 'setInitialManager',
                                      data: 'ND',
                                    });
                                    setInitialManager(null);
                                  }}
                                  aria-label="Alterar responsável por apreciação."
                                >
                                  <AiOutlineEdit className="text-grey-dark" size={25} />
                                </button>
                              ) : (
                                <button onClick={() => handleSearchManager()} aria-label="Alterar responsável por apreciação.">
                                  <RiSearchLine className="text-grey-dark" size={25} />
                                </button>
                              )}
                            </div>

                            <span className="text-yellow text-xs mt-2 block">
                              Essa pessoa é responsável por realizar a apreciação desta entrega? Caso não seja ela, você pode
                              alterá-la, clicando no ícone acima.
                            </span>

                            <span className="text-yellow text-xs mt-1 block">
                              Atenção: Não deve ser indicado novo líder nas situações em que o seu gestor tenha ausência
                              temporária (férias, abonos, licença paternidade, folgas, viagem a serviço, licença saúde até 15
                              (quinze) dias etc.).{' '}
                            </span>

                            {searching && (
                              <div className="mt-6 flex-1 bg-rich-black bg-opacity-80 p-8 rounded-3xl">
                                <p className="animate-pulse text-yellow">Recuperando informações...</p>
                              </div>
                            )}

                            {!!searchResultsManager && searchResultsManager.length > 0 && (
                              <div className="mt-4">
                                <p className="mb-5">Resultado da pesquisa:</p>
                                <div className="flex-1 bg-rich-black bg-opacity-80 py-4 px-8 rounded-3xl h-[30vh] lg:h-auto overflow-y-auto lg:overflow-y-visible">
                                  {searchResultsManager.map(item => (
                                    <div
                                      key={item._id}
                                      onClick={() => changeManager(item)}
                                      className={`cursor-pointer hover:opacity-75 w-full flex flex-row items-center justify-between border-b border-prussian-blue pb-4 mb-4`}
                                    >
                                      <div className="w-[44px] h-[44px] ml-2">
                                        <UserAvatar
                                          data={{
                                            image: item.image,
                                            ...item,
                                          }}
                                        />
                                      </div>
                                      <p className="flex-1 pl-3 pr-2 w-3/5">
                                        <span className="block text-xs font-thin">
                                          <strong className="text-base font-semibold">{item.nome_guerra}</strong>
                                        </span>
                                        <span className="text-xs font-thin">
                                          {item.nome} ({item.chave})
                                        </span>
                                        {!!item?.diretoria || !!item?.funcao ? (
                                          <span className="block text-xs font-thin">
                                            {!!item?.diretoria && (
                                              <span className="text-electric-blue uppercase">{item?.diretoria}</span>
                                            )}
                                            {!!item?.diretoria && !!item?.funcao && ' - '}
                                            {item?.funcao ? `${item?.funcao}` : ''}
                                          </span>
                                        ) : null}
                                      </p>
                                    </div>
                                  ))}

                                  <div className="text-center pt-2 text-white font-base font-light">
                                    Não encontrou quem procura? Experimente buscar por nome e sobrenome ou matrícula.
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>

                        {!!periodEnd?.length && !periodEndIsValid ? (
                          <p className="block font-light text-yellow">
                            <p className="block font-light text-yellow">
                              A data da entrega deve estar entre 01/07/2024 e último dia deste mês. Altere para prosseguir.
                            </p>
                          </p>
                        ) : null}

                        {!!title && !indicator?.value ? (
                          <p className="block font-light text-yellow">
                            {!!indicatorsList
                              ? 'Você precisa selecionar um indicador para continuar.'
                              : 'Você não possui indicador, portanto não pode cadastrar realização.'}
                          </p>
                        ) : null}

                        {needNec.length > 0 && !selectedNec?.value && necIsSearched ? (
                          <p className="block font-light text-yellow">
                            Você precisa selecionar um NEC/INICIATIVA para essa realização.
                          </p>
                        ) : null}

                        {needNec.length > 0 && !demandanteValue && necIsSearched ? (
                          <p className="block font-light text-yellow">
                            Você precisa selecionar um Demandante para essa realização.
                          </p>
                        ) : null}

                        {!titleLength ||
                          titleLength?.textLength < minTitleLength ||
                          (titleLength?.fullLength > maxTitleLength && (
                            <p className="block font-light text-yellow">
                              O Nome da realização inserido ultrapassou o limite máximo de {maxTitleLength} caracteres.
                            </p>
                          ))}
                      </>
                    )}

                    {step === 2 && (
                      <div className="border-2 border-electric-blue rounded-2xl p-8 flex flex-col w-full space-y-2">
                        <div ref={ref => (messageRef.current = ref)} className="text-white text-sm leading-none block font-thin">
                          Detalhes da Realização Destaque
                        </div>
                        <div className="flex flex-row items-center">
                          <div className="h-40 w-full bg-transparent">
                            <TextEditor
                              disableEmoji
                              initialValue={message}
                              maxLength={maxMessageLength}
                              minLength={minMessageLength}
                              onChange={handleChangeMessage}
                            ></TextEditor>
                          </div>
                        </div>
                        <p className="block text-sm text-white font-thin">
                          Na descrição, não se esqueça de demonstrar clareza e objetividade dos resultados e benefícios alcançados
                          por meio da sua realização destaque e fique bem na foto!
                          <br />
                        </p>
                        <div className="text-white text-sm block font-thin pt-4">Resultados da Realização Destaque</div>
                        <div className="flex flex-row items-center">
                          <div className="h-40 w-full bg-transparent">
                            <TextEditor
                              disableEmoji
                              initialValue={resultMessage}
                              maxLength={maxResultLength}
                              minLength={minResultLength}
                              onChange={handleChangeResult}
                            ></TextEditor>
                          </div>
                        </div>
                        <p className="block mt-2 text-sm text-yellow font-thin">
                          Atente-se quanto à classificação do sigilo das informações (IN 421), considerando que o conteúdo ficará
                          visível a todos os participantes.
                        </p>
                        {!messageLength ||
                          messageLength?.textLength < minMessageLength ||
                          (messageLength?.fullLength > maxMessageLength && (
                            <p className="block font-light text-yellow">
                              O Detalhes da Realização Destaque inserido ultrapassou o limite máximo de {maxMessageLength}{' '}
                              caracteres.
                            </p>
                          ))}
                        {!resultLength ||
                          resultLength?.textLength < minResultLength ||
                          (resultLength?.fullLength > maxResultLength && (
                            <p className="block font-light text-yellow">
                              O Detalhes da Realização Destaque inserido ultrapassou o limite máximo de {maxResultLength}{' '}
                              caracteres.
                            </p>
                          ))}
                      </div>
                    )}

                    <div className="flex lg:block justify-center">
                      <div className="p-2 px-45 flex flex-row space-x-8 items-center justify-center">
                        {step > 0 && (
                          <button
                            aria-label={`Voltar para a etapa ${step} de cadastramento de  realização destaque`}
                            onClick={() => {
                              sendPartialLog({
                                type: 'back',
                                location: 'bottom',
                                data: 'setStep(' + (step - 1) + ')',
                              });
                              setStep(step - 1);
                            }}
                            className={`eading-none ring-2 ring-blue-violet-crayola w-full lg:w-auto flex flex-col lg:flex-row items-center bg-transparent text-center text-white rounded py-3 px-4`}
                          >
                            <p className="font-bold text-sm leading-none uppercase">Voltar</p>
                          </button>
                        )}
                        {step < 2 && (
                          <button
                            onClick={() => {
                              sendPartialLog({
                                type: 'next',
                                location: 'bottom',
                                setStep: step + 1,
                              });

                              if (!buttonContinueIsDisabled()) {
                                setStep(step + 1);
                              }
                            }}
                            disabled={buttonContinueIsDisabled()}
                            tabIndex={0}
                            aria-label={`Continuar para a etapa ${step + 2}.`}
                            className={`leading-none disabled:opacity-50 ring-2 ring-slate-blue w-full lg:w-auto flex flex-col lg:flex-row items-center bg-slate-blue text-center text-white rounded py-3 px-4`}
                          >
                            <p className="font-bold text-sm leading-none uppercase">Continuar</p>
                          </button>
                        )}
                        {step === 2 && (
                          <button
                            disabled={buttonContinueIsDisabled()}
                            onClick={() => handleSubmit()}
                            className={`leading-none disabled:opacity-50 ring-2 ring-slate-blue w-full lg:w-auto flex flex-col lg:flex-row items-center bg-slate-blue text-center text-white rounded py-3 px-4`}
                            aria-label="Finalizar cadastramento de realização destaque"
                            tabIndex={0}
                          >
                            <p className="font-bold text-sm leading-none uppercase">
                              {params.id && params.id !== 'cadastrar' ? 'Atualizar' : 'Finalizar'}
                            </p>
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {loading && !submitted && (
                  <div className="space-y-4 mt-12">
                    <div className="flex flex-row items-center justify-center text-xl text-yellow animate-pulse">
                      <div></div>
                      Enviando Realização Destaque...
                    </div>
                  </div>
                )}
              </div>
            </Box>
          )}

          {submitted && (
            <ModalAcessivel
              isOpen={submitted}
              onRequestClose={() => {
                setIsOpen(false);
                document.dispatchEvent(new CustomEvent('reload:partialTask'));
              }}
            >
              <div className="border-2 rounded-3xl relative bg-oxford-blue border-electric-blue p-8 flex flex-col w-[324px] lg:max-w-screen-md justify-center items-center">
                <button
                  aria-label="Fechar modal"
                  className="absolute -top-5 -right-5 button-close"
                  onClick={() => {
                    sendPartialLog({ type: 'close', location: 'submitted' });
                    setIsOpen(false);
                    document.dispatchEvent(new CustomEvent('reload:partialTask'));
                  }}
                >
                  <IoMdCloseCircle size={48} className="text-slate-blue" />
                </button>

                <div className="flex flex-col items-center justify-center">
                  {!submitError && (
                    <>
                      <div className="flex items-center justify-center mb-6">
                        <img src={FeedbackImg} alt="Enviado!" className="w-[173px] block" />
                      </div>
                      <h1 className="block text-2xl font-semibold text-yellow mb-4 text-center" tabIndex={0}>
                        Mandou bem!
                      </h1>
                      <p className="text-sm font-white font-light text-center block" tabIndex={0}>
                        Sua Realização Destaque foi {params.id && params.id !== 'cadastrar' ? 'atualizada' : 'cadastrada'}. Agora
                        você poderá acompanhar o processo de validação da entrega que será realizado pela liderança.
                      </p>
                    </>
                  )}

                  {submitError && (
                    <>
                      <h1 className="block text-2xl font-semibold text-yellow mb-4 text-center" tabIndex={0}>
                        {!!submitError.match(/limite de participações/gi)
                          ? 'Ocorreu um erro ao enviar essa Realização Destaque!'
                          : 'Não deu pra enviar essa Realização Destaque!'}
                      </h1>
                      <p className="text-sm font-white font-light text-center block mb-8" tabIndex={0}>
                        {submitError}
                      </p>{' '}
                      {/* <button
                        className={`leading-none disabled:opacity-50 ring-2 ring-slate-blue w-full lg:w-auto flex flex-col lg:flex-row items-center bg-slate-blue text-center text-white rounded py-3 px-4`}
                        onClick={() => {
                          setStep(0);
                          setSubmitError(undefined);
                          setSubmitted(false);
                          setTarget(bkpTarget);
                        }}
                        aria-label="Ajustar equipe"
                      >
                        Ajustar equipe
                      </button>{' '}
                      <button
                        className={`leading-none disabled:opacity-50 ring-2 mt-4 ring-slate-blue w-full lg:w-auto flex flex-col lg:flex-row items-center  text-center text-white rounded py-3 px-4`}
                        onClick={() => {
                          setIsOpen(false);
                        }}
                        aria-label="Ajustar equipe"
                      >
                        Cancelar envio
                      </button> */}
                    </>
                  )}
                </div>
              </div>
            </ModalAcessivel>
          )}

          {showModalAlert && <Modal description={showModalAlert} onClose={() => setShowModalAlert(false)} />}
          {showModalTutorial && (
            <Modal
              onClose={() => {
                setshowModalTutorial(false);
              }}
              description={''}
            />
          )}
        </ModalAcessivel>
      )}
    />
  );
}
